/**
 * Para descargar el archivo especificado ::
 * @param url - La URL del archivo que se va a descargar.
 * @param fileName - El nombre que se le dará al archivo descargado.
 */

export const handleDescarga = (url: string, fileName: string) => {
	const a = document.createElement('a');
	a.href = url;
	a.target = '_blank';
	a.setAttribute('download', fileName);
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
};
